import { createApp } from 'vue';
import '@fontsource-variable/bricolage-grotesque';
import '@fontsource/atkinson-hyperlegible-next/400.css';
import '@fontsource/atkinson-hyperlegible-next/700.css';
import './style.css';
import App from './App.vue';

createApp(App).mount('#app');
